module.exports = "<h1>Home</h1>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/pages/home/home.component.html
 ** module id = 169
 ** module chunks = 0
 **/